export const ApiUrls = {
  publicConfig: '/config/public', // LIKE COUNTRY LIST ETC
  getCountrie: '/master/country', // LATER ADDED
  getStates: '/master/states',
  getCities: '/master/cities',

  sendOtpRequest: '/auth/otp/request',
  verifyOtpRequest: '/auth/otp/check',

  registerUser: '/auth/register/user',
  applogin: '/auth/login',
  getAccessTokenFromRefreshToken :'/auth/token/refresh',
  forgotResetPassowrd: '/auth/reset_password',
  getEmailFromOtpRequestId: `/auth/email/`,

  getProfile: '/profile',
  updateMyProfile: '/profile',
  updateMyPassword: '/profile/change_password',
  getControllerOTP: '/profile/controller/otp',
  getControllerList: '/controllers',
  getControllerById: '/controllers/{controller_id}',
  getAllMembersOfController: '/controllers/{:controller_id}/members',
  inviteMemberToController: '/controllers/{controller_id}/invite-members',
  validateControllerInvitation: '/controllers/validate-invite?uniqueKey={queryString}',
  acceptControllerInvite: '/controllers/accept-invite',
  deleteInvitedMember: '/controllers/{controller_id}/members/{email}',
  resendInvitation:'/controllers/{controller_id}/members/resend',

  addOrganization: '/organization',
  getMyOrganization: '/organization',
  updateMyOrganization: '/organization',

  getOrgRoles: '/org-roles',
  addNewOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED
  updateOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  getOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  deleteOrgRole: '/org-roles', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS ROLE ID IS REQUIRED
  getOrgRoleOption: '/org-roles/role-option', // BEFORE THIS ORG_ID IS REQUIRED

  getOrgUsers: '/org-users',
  addNewOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED
  updateOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  getOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  deleteOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED
  reinviteOrgUser: '/org-users', // BEFORE THIS ORG_ID IS REQUIRED & AFTER THIS USER ID IS REQUIRED

  getProjects: '/{orgId}/projects',
  getProjectDetail: '/{orgId}/projects/{projectId}',
  addNewProject: '/{orgId}/projects',
  updateProject: '/{orgId}/projects/{projectId}',
  deleteProject: '/{orgId}/projects/{projectId}',
  projectTeamList: '/{orgId}/projects/{projectId}/teams',
  projectUserList: '/{orgId}/projects/{projectId}/users',
  projectUsersMapping: '/{orgId}/projects/{projects}/teams',
  projectRemoveUser: '/{orgId}/projects/{projectId}/teams/{userMappingId}',
};
